import { Size, Variant } from 'components/Form/SelectCards/types';
import React from 'react';
import tw, { TwStyle } from 'twin.macro';

type SelectCardLayoutProps = {
  checked?: boolean;
  illustration?: React.ReactNode;
  icon: React.ReactNode;
  label?: React.ReactNode;
  description?: React.ReactNode;

  size: Size;
  variant: Variant;
  id: string;
};

const VARIANT_STYLES: Record<
  Variant,
  (checked: boolean | undefined) => (TwStyle | false | undefined)[]
> = {
  filled: checked => [tw`border-transparent`, checked && tw`bg-brand-moderate`],
  outlined: checked => [
    tw`border-neutral-quiet`,
    checked && tw`bg-brand-moderate`,
  ],
};

const SIZE_STYLES: Record<Size, TwStyle> = {
  'extra-small': tw`p-2`,
  small: tw`p-4`,
  big: tw`p-6`,
};

export const SelectCardLayout = ({
  icon,
  label,
  description,
  checked,
  variant,
  size,
  id,
  illustration,
}: SelectCardLayoutProps) => {
  const sizeStyles = SIZE_STYLES[size];
  const variantStyles = VARIANT_STYLES[variant](checked);

  return (
    // eslint-disable-next-line jsx-a11y/label-has-for
    <label
      css={[
        tw`bg-white rounded-lg cursor-pointer border-[1.5px]`,
        tw`hover:border-[1.5px] hover:border-brand-moderate`,
        sizeStyles,
        variantStyles,
      ]}
      htmlFor={id}
    >
      <div tw="grid grid-cols-[auto_1fr] gap-2">
        {icon}
        <div>
          {label}
          {description}
        </div>
        {illustration && (
          <div tw="justify-self-center row-start-2 col-span-full md:col-start-3 md:justify-end md:row-start-1">
            {illustration}
          </div>
        )}
      </div>
    </label>
  );
};
